module.exports = __webpack_public_path__ + "img/img-7.9423bcc.jpg";